import { withChartLayout } from 'components/common';
import Mar from 'components/features/chart/mar/Mar';

const MarPage = withChartLayout('Medication Administration Record')(Mar);
export default MarPage;
